import styled from 'styled-components';

export const ReportsContainer = styled.div`
  padding: 0 30px;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
  gap: 12px;
`;
